// AppMetrica redirect URLs
export const APPMETRICA_ORGANIC_URL = 'https://redirect.appmetrica.yandex.com/serve/462021737194816662';
export const APPMETRICA_UTM_URL = 'https://redirect.appmetrica.yandex.com/serve/462021725534559149';

// Deep link configuration
export const DEEP_LINK_SCHEME = 'whiteswan://(main)';
export const DEEP_LINK_TIMEOUT_IOS = 2500; // milliseconds to wait before fallback to App Store on iOS
export const DEEP_LINK_TIMEOUT_ANDROID = 2000; // milliseconds to wait before fallback to App Store on Android
